import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import IconCheck from "@material-ui/icons/Check";
import { Grid, Typography } from "@material-ui/core";
import { Close, KeyboardArrowUp, KeyboardArrowDown } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  // actionButton: {
  //   fontSize: 16,
  //   padding:'5px',
  //   cursor:'pointer',
  //   textAlign:'left',
  //   backgroundColor:'var(--backgroundcolor)',
  //   color:'var(--darker)',
  //   borderRadius:'5px'
  //   // color:'#5F6368',
  //   // "&:hover": {
  //   //     backgroundColor:'#E8F0FE'
  //   // }
  // },

  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  rowItem: {
    padding: "5px 8px",
    cursor: "pointer",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "#E8F0FE",
    },
  },
  iconStyle: {
    fontSize: "14px",
    // color:'#5F6368'
  },
}));

export default function JourneyClass(props) {
  const classOptions = {
    Any: "Any",
    M: "Economy",
    W: "Economy Premium",
    C: "Business",
    F: "First Class",
  };
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [classType,setClassType]=React.useState('Any');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdate = (val) => {
    if (props.onChange) props.onChange(val);
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  //  React.useEffect(()=>{
  //   return props?.onChange(classType)
  //  },[classType])

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div className="action-button" onClick={handleClick}>
        <Typography component="span"> {classOptions[props.value]}</Typography>

        <Typography component="span" style={{ marginLeft: 10 }}>
          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </Typography>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div
          style={{
            width: "200px",
            // backgroundColor: "var(--backgroundcolor)",
            borderRadius: "5px",
            padding: "8px",
          }}
        >
          {Object.keys(classOptions).map((item) => (
            <div
              className={`select-option ${item == props.value ? "active" : ""}`}
              onClick={() => handleUpdate(item)}
            >
              {/* {" "}
              {item == props.value ? (
                <IconCheck style={{ fontSize: 15 }} />
              ) : (
                <>&nbsp;&nbsp;&nbsp;</>
              )}{" "} */}
              <Typography
                component="span"
                style={{ color: "var(--textdarker)" }}
              >
                {classOptions[item]}
              </Typography>
            </div>
          ))}
        </div>
      </Popover>
    </div>
  );
}

JourneyClass.defaultProps = {
  value: "Any",
};
